module.exports = __webpack_public_path__ + "img/zdid_sel.aefe0085.svg";